"use client"
import { useFavorites } from "../context/FavoritesContext"
import { useAuth } from "../context/AuthContext"
import { useNavigate } from "react-router-dom"

const FavoriteButton = ({ itemId, itemType, className }) => {
  const { user } = useAuth()
  const {
    isTempleInFavorites,
    isPilgrimageInFavorites,
    toggleTempleInFavorites,
    togglePilgrimageInFavorites,
    loading,
  } = useFavorites()
  const navigate = useNavigate()

  const isInFavorites = itemType === "temple" ? isTempleInFavorites(itemId) : isPilgrimageInFavorites(itemId)

  const handleToggleFavorite = async (e) => {
    e.preventDefault()
    e.stopPropagation()

    if (!user) {
      // Redirect to login if user is not authenticated
      navigate("/login?redirect=favorites")
      return
    }

    if (itemType === "temple") {
      await toggleTempleInFavorites(itemId)
    } else {
      await togglePilgrimageInFavorites(itemId)
    }
  }

  return (
    <button
      onClick={handleToggleFavorite}
      disabled={loading}
      className={`rounded-full p-2 transition-colors ${className || ""}`}
      aria-label={isInFavorites ? "Remove from favorites" : "Add to favorites"}
    >
      {isInFavorites ? (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 fill-current" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
            clipRule="evenodd"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-gray-400 hover:text-red-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      )}
    </button>
  )
}

export default FavoriteButton